import { Component, Input, ChangeDetectionStrategy, OnInit, ChangeDetectorRef } from '@angular/core';
import { TicketModel } from './ticket.model';
import { TicketLineModel } from './ticketline.model';
import { TicketTaxModel } from './tickettax.model';
import { AccountsAndTaxesModel } from './accountsandtaxes.model';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { Router } from "@angular/router";
import { ActivityService } from '../../user/activity/activity.service';
import { TaxCalculator } from '../../../shared/taxCalculator';
import { ActualSelected, Utils } from '../../../shared/utils';
import { TicketService } from './ticket.service';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';
import { UserCompanyModel } from '../../user/usercompany/usercompany.model';
import { UserCompanyService } from '../../user/usercompany/usercompany.service';
import { AccountModel } from './account.model';
import { AccountingModelService } from '../../user/accountingModel/accountingModel.service';
import { TicketFormItemComponent } from './ticket-form-item.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { UntypedFormControl } from '@angular/forms';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { PartnersService } from '../../user/partnersequity/partners/partners.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { PartnersModel } from '../../user/partnersequity/partners/partners.model';
import { BILL_METHODS, consts } from '../../../consts';
import { ContactFormV2Component } from '../../../modules_v2/contacts/components/contact-form-v2/contact-form-v2.component';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { map } from 'rxjs/operators';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'convfact-ticket-form',
    templateUrl: './ticket-form.component.html',
    styleUrls: ['./ticket.component.css'],
    standalone: false
})

export class TicketFormComponent implements OnInit {
  @Input() contactList: ContactModel[];
  userCompany: UserCompanyModel;
  entranceList: AccountModel[] = [];

  @Input() ticket: TicketModel;
  @Input() accountsAndTaxes: AccountsAndTaxesModel;
  @Input() bankAccounts: BankAccountModel[];
  @Output() onSave = new EventEmitter<any>();
  @Input() contacts: ContactModel[] = [];

  @Input() errors: object;

  ready: boolean = false;

  newContactLoaded = new BehaviorSubject<boolean>(true);

  payMethodCtrl: UntypedFormControl;
  filteredPayMethod: Observable<any>;

  entranceCtrl: UntypedFormControl;
  filteredEntrances: Observable<any[]>;

  contactCtrl: UntypedFormControl;
  filteredContacts: Observable<ContactModel[]>;

  public efectivoList: Efectivo[] = [];
  public sociosList: PartnersModel[] = [];

  contactSelected: ContactModel;
  projects: MasterModel[] = [];
  isProjectEnable: boolean = false;

  billMethods = [
    { id: consts.TYPEPAY_CASH, data: consts.TYPEPAY_CASH },
    { id: consts.TYPEPAY_SEPA, data: consts.TYPEPAY_SEPA },
    { id: consts.TYPEPAY_BANKTRANSFERENCE, data: consts.TYPEPAY_BANKTRANSFERENCE },
    { id: consts.TYPEPAY_CONFIRMING, data: consts.TYPEPAY_CONFIRMING },
    { id: consts.TYPEPAY_PAGARES, data: consts.TYPEPAY_PAGARES },
    { id: consts.TYPE_TARJETA, data: consts.TYPE_TARJETA },
    { id: consts.TYPE_SOCIO, data: consts.TYPE_SOCIO },
  ];

  constructor(
    private taxCalculator: TaxCalculator,
    private userCompanyService: UserCompanyService,
    private accountingModelService: AccountingModelService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private contactService: ContactService,
    private router: Router,
    private activityService: ActivityService,
    public ticketService: TicketService,
    private efectivoService: EfectivoService,
    private partnersService: PartnersService,
    protected snackBar: MatSnackBar,
    private masterService: MasterService,
  ) { }


  public paidedCheck: boolean = false;


  ngOnInit() {
    this.ready = false;

    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
      this.isProjectEnable = activity.isProject;
    });


    this.activityService.loadData(ActualSelected.activitySelected).then(response => {
      this.ticket.entranceAccount = response.ticketAccountEntrance;
      this.ticket.expenseAccount = response.ticketAccountExpense;
    })

    this.ready = true;


    this.contactService.getListClients().then(response => {
      this.contactList = response;

      if (!this.ticket.receiverUid) {
        const defaultContact = this.contactList.find(c => c.companyName === 'Factura simplificada');
        if (defaultContact) {
          this.ticket.receiverName = defaultContact.companyName;
          this.ticket.receiverUid = defaultContact.uid;
        }
      }

    }).catch(err => {
    });

    this.userCompanyService.loadData().then(response => {
      this.userCompany = response;

      if (this.ticket.entranceAccount == null || this.ticket.entranceAccount) {
        let account = null;
        if (this.userCompany.isSalesInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }

        if (this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7050000001')[0];
        }

        if (this.userCompany.isSalesInvoice && this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }

        if (account) {
          this.ticket.entranceAccount = account.number + ' - ' + account.name;
        }
      }
    });

    this.efectivoService.list()
      .then(listadoEfectivos => {
        this.efectivoList = listadoEfectivos
      });

    this.partnersService.list()
      .then(response => {
        this.sociosList = response
      });

    this.payMethodCtrl = new UntypedFormControl();
    this.filteredPayMethod = this.payMethodCtrl.valueChanges
      .pipe(
        map(method => this.filterPayMethod(method))
      );

    this.contactCtrl = new UntypedFormControl();
    this.filteredContacts = this.contactCtrl.valueChanges
      .pipe(
        map(contact => contact && typeof contact === 'object' ? contact.companyName : contact),
        map(name => this.filterContacts(name))
      );

    this.accountingModelService.getList('ingreso').then(data => {
      data.forEach(account => {
        if (Utils.AccountIsForIncomes(account.type)) {
          const temp: AccountModel = new AccountModel();
          temp.name = account.name;
          temp.number = account.number;
          temp.type = account.type;
          this.entranceList.push(temp);
        }
      });
    });


    this.entranceCtrl = new UntypedFormControl();
    this.filteredEntrances = this.entranceCtrl.valueChanges
      .pipe(
        map(account => account && typeof account === 'object' ? account.number : account),
        map(name => this.filterEntrances(name))
      );

    this.masterService.getProjects().subscribe(data => {
      this.projects = data;
      this.cdr.detectChanges();
    });

    this.ready = true;
  }

  newContact(isExpense: boolean) {
    const contactScratch = new ContactModel();

    if (isExpense === false) {
      contactScratch.isProvider = false;
      contactScratch.isClient = true;
    }

    contactScratch.isPhysical = true;

    const dialogNewContact = ContactFormV2Component.open(this.dialog, { scratch: contactScratch });

    this.newContactLoaded.next(false);

    dialogNewContact
      .pipe(
        map(value => {
          if (value === undefined) {
            this.newContactLoaded.next(true);
          }
          return value;
        })
      )
      .subscribe(result => {
        if (result !== undefined) {
          this.contactService.getListClients()
            .then(response => {
              if (response.length == this.contactList.length) {
                this.contactList = response;
                this.newContactLoaded.next(null);
              } else {
                this.contactList = response;
                this.newContactLoaded.next(true);
              }
            })
            .catch(err => {
              this.newContactLoaded.next(true);
              this.displayInfo('Ha ocurrido un error inesperado al obtener el listado de contactos');
            });
        }
      });
  }

  filterEntrances(val) {
    const self = this;
    for (const account of this.entranceList) {
      if (account.number === val) {
        self.ticket.entranceAccount = account.number;
      }
    }

    return val ? this.entranceList.filter(s => s.number.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.entranceList;
  }

  filterContacts(val) {
    const self = this;
    for (const contact of this.contacts) {
      if (contact.companyName === val) {
        self.ticket.receiverUid = contact.uid;
        this.contactService.loadData(self.ticket.receiverUid).then(response => {
          this.contactSelected = response;
        });
      }
    }

    const normalizedValue = this.normalize(val);
    return val ? this.contacts.filter(contact => this.normalize(contact.companyName).includes(normalizedValue))
      : this.contacts;
  }

  filterPayMethod(val) {
    const self = this;
    for (const method of this.billMethods) {
      if (method === val) {
      }
    }

    return val ? this.billMethods.filter(s => s.id.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.billMethods;
  }

  private normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase();
  }

  preventNullOrEmptyValues(ticket: TicketModel) {
    for (let i = 0; i < ticket.ticketLines.length; i++) {

      if (ticket.ticketLines[i].discount == null) {
        ticket.ticketLines[i].discount = 0;
      }
      if (ticket.ticketLines[i].quantity == null) {
        ticket.ticketLines[i].quantity = 0;
      }
      if (ticket.ticketLines[i].unityAmount == null) {
        ticket.ticketLines[i].unityAmount = 0;
      }

      if (this.ticket.entranceAccount == null || this.ticket.entranceAccount) {
        let account = null;
        if (this.userCompany.isSalesInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }

        if (this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7050000001')[0];
        }

        if (this.userCompany.isSalesInvoice && this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }
        if (account) {
          this.ticket.entranceAccount = account.number + ' - ' + account.name;
        }
      }
    }

    this.userCompanyService.loadData().then(response => {
      this.userCompany = response;

      if (this.ticket.entranceAccount == null || this.ticket.entranceAccount) {
        let account = null;
        if (this.userCompany.isSalesInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }

        if (this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7050000001')[0];
        }

        if (this.userCompany.isSalesInvoice && this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }

        if (account)
          this.ticket.entranceAccount = account.number + ' - ' + account.name;
      }
    });

    this.partnersService.list().then(response => this.sociosList = response);

    this.efectivoService.list().then(listadoEfectivos => this.efectivoList = listadoEfectivos)
  }

  onSelectContact(companyName) {
    const contact = this.contactList.filter(c => c.companyName == companyName)[0];
    this.ticket.receiverUid = contact.uid;

    this.contactService.loadData(this.ticket.receiverUid).then(response => {
      this.contactSelected = response;

      this.ticket.entranceAccount = response.entranceAccount;
      this.ticket.expenseAccount = response.expenseAccount;

      let account = null;
      if (this.ticket.entranceAccount == null || this.ticket.entranceAccount == '') {
        if (this.userCompany.isSalesInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }

        if (this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7050000001')[0];
        }

        if (this.userCompany.isSalesInvoice && this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }
      } else {
        account = this.entranceList.filter(c => c.number == response.entranceAccount)[0];

      }

      if (account) {
        this.ticket.entranceAccount = account.number + ' - ' + account.name;
      }

    });
  }

  calcularSubtotal() {
    return this.taxCalculator.calcularSubtotal(this.ticket);
  }

  calcularTotal() {
    this.ticket.total = this.taxCalculator.calcularTotal(this.ticket);
    return this.ticket.total;
  }

  public save(ticket): void {

    // Validaciones
    if (this.paidedCheck) {

      if (Utils.IsNullOrEmpty(this.ticket.typePay)) {
        this.snackBar.open('El campo "Tipo de cobro" es obligatorio', 'Cerrar', {
          duration: 3000
        });
        return;
      }

      if (this.ticket.typePay === 'Efectivo') {

        this.ticket.partnersId = 0;
        this.ticket.bankAccountId = '';

        if (Utils.IsNullOrEmpty(this.ticket.efectivoId)) {
          this.snackBar.open('No ha seleccionado una caja o efectivo', 'Cerrar', {
            duration: 3000
          });
          return;
        }

      }
      //project
      if (Error) {

        ticket.projectUid = this.ticket.projectUid;


        this.ticketService.saveRequestUpdateValue(true);
        this.preventNullOrEmptyValues(ticket);

      }


      if (this.ticket.typePay === 'Socio') {

        this.ticket.efectivoId = '';
        this.ticket.bankAccountId = '';

        if (this.ticket.partnersId == null || this.ticket.partnersId == 0) {
          this.snackBar.open('No ha seleccionado a un socio', 'Cerrar', {
            duration: 3000
          });
          return;
        }

      }

      if (this.ticket.typePay === 'Transferencia bancaria' || this.ticket.typePay === 'Remesa en cuenta' ||
        this.ticket.typePay === 'Tarjeta' || this.ticket.typePay === 'Confirming' || this.ticket.typePay === 'Pagarés'
      ) {

        this.ticket.efectivoId = '';
        this.ticket.partnersId = 0;

        if (Utils.IsNullOrEmpty(this.ticket.bankAccountId)) {
          this.snackBar.open('No ha seleccionado una cuenta bancaria', 'Cerrar', {
            duration: 3000
          });
          return;
        }

      }

    }

    // Si no esta marcado quitamos el valor de 'paided'
    // No hace falta quitar el valor del resto de elementos como pueden ser 'typepay', etc
    // ... ya que añadiremos o no el cobro en base a si 'paided' no es null
    if (!this.paidedCheck) {
      this.ticket.paided = null;
    }

    // Controlamos que todas las lineas de base tengan impuestos
    const invoiceLinesHaveTaxes: string = this.invoiceLinesHaveTaxes(ticket);

    if (!Utils.IsNullOrEmpty(invoiceLinesHaveTaxes)) {
      this.displayInfo(invoiceLinesHaveTaxes);
      return;
    }



    this.ticketService.saveRequestUpdateValue(true);
    this.preventNullOrEmptyValues(ticket);
    this.onSave.emit(ticket)
  }

  private invoiceLinesHaveTaxes(preinvoice: any): string {

    if (preinvoice.ticketLines) {

      for (let i = 0; i < preinvoice.ticketLines.length; i++) {

        if (preinvoice.ticketLines[i].taxes && preinvoice.ticketLines[i].taxes.length === 0) {
          return 'Compruebe que todos sus conceptos incluyan al menos un impuesto';
        }

        if (preinvoice.ticketLines[i].taxes && !preinvoice.ticketLines[i].taxes.find(x => (x.type === 'IVA' || x.type === 'IGIC'))) {
          return 'Incluya al menos un impuesto indirecto (IVA o IGIC) en cada concepto';
        }

      }

    }

    return '';
  }

  changeToggle(element, other) {
    this.ticket[other] = (this.ticket[element]);

  }

  public paided(): void {
    this.ticket.paided = new Date();
  }

  public selectionChangeTypePay(event: MatSelectChange): void {

    if (event.value === 'Efectivo') {
      if (this.efectivoList.length === 1) {
        this.ticket.efectivoId = this.efectivoList[0].uid;
      }
    }

    if (event.value === 'Socio') {
      if (this.sociosList.length === 1) {
        this.ticket.partnersId = this.sociosList[0].uid;
      }
    }

    if (event.value === 'Transferencia bancaria' || event.value === 'Remesa en cuenta' || event.value === 'Tarjeta' || event.value === 'Confirming' || event.value === 'Pagarés') {
      if (this.bankAccounts.length === 1) {
        this.ticket.bankAccountId = this.bankAccounts[0].id;
      }
    }

  }

  onSelectTypePay() {
    if (this.ticket.typePay != '') {
      this.paidedCheck = true;
      this.paided();
    }
  }

  addInvoiceLine() {
    let line = new TicketLineModel();

    if (this.contactSelected && this.contactSelected.taxClientUid != null) {
      const tax: TicketTaxModel = this.accountsAndTaxes['taxes'].find(x => x.uid === this.contactSelected.taxClientUid);
      line.taxes.push(tax);
    }
    if (this.contactSelected && this.contactSelected.taxClientSecondUid != null) {
      const tax: TicketTaxModel = this.accountsAndTaxes['taxes'].find(x => x.uid === this.contactSelected.taxClientSecondUid);
      line.taxes.push(tax);
    }

    const dialog = this.dialog.open(TicketFormItemComponent, {
      width: '580px',
      data: { taxes: this.accountsAndTaxes.taxes, item: line },
    }).afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        line = result.item;
        line.position = this.ticket.ticketLines.length;
        this.ticket.ticketLines.push(line);
      }
      this.cdr.detectChanges();
    });
  }

  removeInvoiceLine(invoiceLine) {
    this.ticket.ticketLines.splice(this.ticket.ticketLines.indexOf(invoiceLine), 1);
  }

  toggleEditMode(index) {
    const dialog = this.dialog.open(TicketFormItemComponent, {
      data: { taxes: this.accountsAndTaxes.taxes, item: this.ticket.ticketLines[index] },
    }).afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.ticket.ticketLines[index] = result.item;
      } else {

      }
      this.cdr.detectChanges();
    });

  }

  calcularTotalesLinea(ticketLine) {
    ticketLine.totalLine = this.taxCalculator.calcularTotalLinea(ticketLine);
    return ticketLine.totalLine;
  }

  saveLine(index, item) {
    // this.item.invoiceLines[index] = item;
  }

  getStrTaxes(taxes: any[]) {
    if (taxes != null) {
      if (taxes.length > 0 && taxes[0] != null) {
        return taxes.map(tax => tax.name).join(', ');
      }
    }
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, 'Cerrar', options);
  }

  public trackByIndex(i: number) { return i; }

}
